<template>
  <div :class="{nav_warp: true,b_color_2px: true,tj_nav_warp: tjstyle,gd_nav_warp: gdstyle}">
    <div v-if="tjstyle || gdstyle" :class="{logo: true,gdlogo: gdstyle}">
      <img :src="publicPath + 'logo_tianjin.png' + '?time=' + new Date().getTime()" alt="">
    </div>
    <div class="nav_box">
      <div class="logo_box" v-if="!tjstyle && !gdstyle "><img class="img" :src="publicPath + 'pclogo.png' + '?time=' + new Date().getTime()" /></div>

      <ul class="nav_list hover_color" :class="platformInfo.appId === '2DW29x025k8'?'nav_list2':''">
        <li>
          <router-link :class="$route.path == '/home' ? 'f_b_color_2px' : ''" to="/home">首页</router-link>
        </li>
        <li>
          <router-link :class="($route.path == '/policy' || $route.path == '/policyDetails')  ? 'f_b_color_2px' : ''" to="/policy">政策法规</router-link>
        </li>
        <li>
          <router-link :class="($route.path == '/news' || $route.path == '/newsDetails')  ? 'f_b_color_2px' : ''" to="/news">新闻资讯</router-link>
        </li>
        <li>
          <router-link :class="($route.path == '/job' || $route.path == '/jobDetails') ? 'f_b_color_2px' : ''" to="/job?priority=1">求职招聘</router-link>
        </li>
        <li v-if="platformInfo.appId === '2DW29x025k8'"  @mouseenter="visbili = true" @mouseleave="visbili = false">
          <div class="textTJ">在线评测</div>
        </li>
        <!-- <li v-if="platformInfo.appId === 'app71rrf9ksr'">
          <router-link :class="$route.path == '/sxZphActivity' ? 'f_b_color_2px' : ''" to="/sxZphActivity">山西招聘活动</router-link>
        </li> -->
        <li v-if="platformInfo.appId === '73x94y71svg'">
          <router-link :class="$route.path == '/sdActivity' ? 'f_b_color_2px' : ''" to="/sdActivity">云端送岗进军营</router-link>
        </li>
      </ul>
      <div :class="{mr_20: tjstyle,gdmr_20: gdstyle}" style="width:126px">
        <!-- GDs7Yz9HVP9Y 广东 -->
        <div v-if="platformInfo.appId !== 'GDs7Yz9HVP9Y'"  :class="[platformInfo.appId === 'app71rrf9ksr'?'invite_btn btnbg2 f_color_1px':'invite_btn btnbg1 f_color_1px'] " @click="enterCompany('1')">我是企业<i class="el-icon-arrow-right"></i></div>
        <div :class="[platformInfo.appId === 'app71rrf9ksr'?'invite_btn btnbg2 f_color_1px':'invite_btn btnbg1 f_color_1px'] " style="margin:6px 0;" @click="enterCompany('2')">我要找工作<i class="el-icon-arrow-right"></i></div>
        <div :class="[platformInfo.appId === 'app71rrf9ksr'?'invite_btn btnbg2 f_color_1px':'invite_btn btnbg1 f_color_1px'] " @click="enterCompany('3')">事务机构登录<i class="el-icon-arrow-right"></i></div>
        <!-- <div :class="[platformInfo.appId === '73x94y71svg'?'invite_btn btnbg1 f_color_1px':'',platformInfo.appId === 'app71rrf9ksr'?'invite_btn btnbg2 f_color_1px':'', platformInfo.appId === '75y7k29ehv'?'invite_btn btnbg3 f_color_1px':'',platformInfo.appId === '2DW29x025k8'?'invite_btn btnbg4 f_color_1px':''  ] " style="margin-top:6px" @click="enterCompanyTwo()">事务机构登录<i class="el-icon-arrow-right fc_color"></i></div> -->
        <!-- <div v-if="platformInfo.appId === '2DW29x025k8'" :class="[platformInfo.appId === '2DW29x025k8'?'invite_btn btnbg4 f_color_1px':'' ] " style="margin-top:6px" @click="enterCompanyTwo()">事务机构登录<i class="el-icon-arrow-right fc_color"></i></div> -->
      </div>
      <div v-if="visbili" @mouseenter="visbili = true" @mouseleave="visbili = false" class="TJdialog">
        <img src="../assets/img/active/test.png" alt="">
      </div>
    </div>

  </div>
</template>
  
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      index: '/home',
      visbili:false
    }
  },
  computed: {
    ...mapState(['platformInfo', 'publicPath']),
    tjstyle() {
      return this.platformInfo.appId === '2DW29x025k8'
    },
    gdstyle() {
      return this.platformInfo.appId === 'GDs7Yz9HVP9Y'
    }
  },
  methods: {
    checkNav() {
      this.index = this.$route.path;
    },
    // 81联聘企业站
    enterCompany(type) {
      if(type=='1'){ 
         window.open("https://bsp.81lianpin.com/mana/home"); 
      }else if(type=='2'){
         this.$router.push({ path: `/job` });
      }else if(type=='3'){
         window.open("https://bsp.81lianpin.com/mana/orglogin"); 
      } 
    },
   
  }
}
</script>
  
<style lang="scss" scoped>
.nav_warp {
  background: #fff;
}
.mr_20,.gdmr_20 {
  margin-right: 20px;
}
.tj_nav_warp {
  position: relative;
  // overflow: visible;
  width: 1200px;
  margin: 0 auto;
  margin-top: 135px;
}
.gd_nav_warp{
  position: relative;
  // overflow: visible;
  width: 1200px;
  margin: 0 auto;
  margin-top: 135px;
}
.logo {
  position: absolute;
  top: -118px;
  img {
    width: 644px;
    height: 101px;
  }
}
.gdlogo img{
  width: 645px !important;
  height: 109px !important;
}
.nav_box {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo_box {
  width: 214px;
  height: 67px;
}
.invite_btn {
  font-size: 12px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  height: 24px;
  line-height: 24px;
  text-align: center;
  padding-left: 4px;
}
.nav_list {
  width: 800px;
  height: 98px;
  display: flex;
  justify-content: space-around;
}
.nav_list.nav_list2{
  width: 1000px;
}
.nav_list li a {
  display: inline-block;
  height: 98px;
  line-height: 98px;
  font-size: 18px;
  padding: 0 15px;
  color: #888;
}
.nav_list li .textTJ {
  display: inline-block;
  height: 98px;
  line-height: 98px;
  font-size: 18px;
  padding: 0 15px;
  color: #888;
   cursor: pointer; 
}
.btnbg1{
  background: #EEF6FF;
}
.btnbg2{
  background: #FFF6F6;
}
.TJdialog{
  position: absolute !important;
  bottom: -165px !important;
  left: 850px !important;
  width: 200px !important;
  height: 200px !important;
  z-index: 99;
}
</style>
  
  
  
  
  
  






// WEBPACK FOOTER //
// src/components/Nav1.vue